module.exports = "/images/vendor/flag-icon-css/flags/1x1/ch.svg?252c409ba2d2600aaf08946b9280b670";